<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  $margin-left-right: utils.in_rem(24px);

  .footer {
    width: calc(100% - 2 * $margin-left-right);
    display: flex;
    justify-content: flex-end;
    padding: utils.in_rem(12px) 0;
    gap: utils.in_rem(16px);
    margin: 0 $margin-left-right;
    border-top: 1px solid colors.get(interfaceSwGrey_10);
  }
</style>

<script>
  // Stores
  import {
    isValidEmail,
    regularizedPhone,
    showToast,
  } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import { removeContact } from "../../../../../api/extension";
  import {
    flagContactReasonStore,
    flaggedContacts,
  } from "../../ProfileContactSideBar/stores";
  import { activePopUpModalStore, candidateStore } from "../../stores";
  // Components
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";
  import FlagContactSelector from "./FlagContactSelector.svelte";

  export let contactToFlag = "";

  const confirm = () => {
    activePopUpModalStore.set(null);
  };
  const cancel = () => {
    activePopUpModalStore.set(null);
  };

  const isEmail = isValidEmail(contactToFlag);

  const wrappedConfirm = async () => {
    const contact = contactToFlag.trim();
    // async api call
    return removeContact({
      contact,
      candidateId: $candidateStore.candidateId,
      socialLinks: $candidateStore.socialLinks || [],
      photo: null,
      reason: $flagContactReasonStore.value || "",
      reasonExplanation:
        ($flagContactReasonStore.value === "other" &&
          $flagContactReasonStore.explanation) ||
        "",
    }).then(() => {
      flaggedContacts.update((x) => {
        const normalizedContact = isEmail ? contact : regularizedPhone(contact);
        x.push(normalizedContact);
        return x;
      });
      showToast({
        title: `Flagged ${contactToFlag}`,
        type: "success",
      });
      confirm();
    });
    // For other functionality from parent (e.g. to close the modal)
  };
</script>

<Modal onclose={cancel} blur="4px" closeButton={false}>
  <div slot="header"><h2>Report {contactToFlag}</h2></div>
  <FlagContactSelector {isEmail} />
  <div class="footer">
    <Button class="flex-1" onclick={cancel} kind="ghost-blue">Cancel</Button>
    <Button class="flex-1" onclick={wrappedConfirm}>Ok</Button>
  </div>
</Modal>
